import React from 'react';
import PropTypes from 'prop-types';
import {
    Bullet,
    Card,
    ContactCta,
    Cta,
    Heading,
    ImgContainer,
    Points,
    SubText,
    Text,
    TopContent,
} from './fraudPreventionCard.style';
import CheckMarkIcon from '../../../../images/Icons/icon-checkmark-styled.svg';
import { useModal } from '../../../../context/ModalContext';

const FraudPreventionCard = ({ data, secondary }) => {
    const { openModal } = useModal();

    return (
        <Card>
            <TopContent>
                <Heading>{data.heading}</Heading>
                <SubText>{data.subText}</SubText>
                <ImgContainer>
                    <img src={data.img} alt="graphic" />
                </ImgContainer>
                <Points>
                    {data?.points.map((point, index) => (
                        <div key={point?.substring(0, 10) + index}>
                            <Bullet>
                                <img src={CheckMarkIcon} alt="checkmark-icon" />
                            </Bullet>
                            <Text>{point}</Text>
                        </div>
                    ))}
                </Points>
            </TopContent>
            {data?.cta?.isPopup ? (
                <ContactCta type="button" onClick={() => openModal('contact')}>
                    {data.cta.text}
                </ContactCta>
            ) : (
                <Cta to={data?.cta?.link}>{data?.cta.text}</Cta>
            )}
        </Card>
    );
};

FraudPreventionCard.propTypes = {
    data: PropTypes.object,
    secondary: PropTypes.bool,
};

export default FraudPreventionCard;
